import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Result, Steps } from 'antd';
import PropertyActions, { PropertySelectors } from '@redux/PropertyRedux';
import PricingForm from './PricingForm';
import PropertyNoteForm from './PropertyNoteForm';
import {
  mergeSections,
  convertPriceTimeArray,
  convertPriceTimeObject,
  buildValues
} from './convertSchema';

const { Step } = Steps;

const steps = [
  {
    title: 'Services',
    key: 'main-service'
  },
  {
    title: 'Additional Services',
    key: 'addons'
  },
  {
    title: 'Special Services',
    key: 'specialServices'
  },
  {
    title: 'Submit'
  }
];

function PropertyPricingForm(props) {
  const {
    propertyId,
    activeGlobalSetting,
    setPricingValues,
    propertyPricingInfo,
    closeForm
  } = props;

  const [current, setCurrent] = useState(0);

  if (!activeGlobalSetting) {
    return (
      <Result
        status="warning"
        title="Sorry, please activate global property setting first"
      />
    );
  }

  if (!propertyPricingInfo) {
    return null;
  }

  const { data } = activeGlobalSetting;

  const { addons, specialServices, ...mainServices } = data || {};

  const mainServiceTypes = Object.keys(mainServices);

  const mainKeys = ['addons', ...mainServiceTypes];

  const {
    addons: propertyAddons,
    specialServices: propertySpecialServices,
    ...propertyMainServices
  } = propertyPricingInfo || {};

  const formData = [
    mergeSections(
      mainServiceTypes.map(serviceType =>
        convertPriceTimeArray(
          mainServices[serviceType],
          propertyMainServices[serviceType],
          serviceType
        )
      )
    ),
    mergeSections([convertPriceTimeObject(addons, propertyAddons, 'addons')]),
    mergeSections(
      Object.keys(specialServices || {}).map(serviceKey =>
        convertPriceTimeArray(
          specialServices[serviceKey],
          propertySpecialServices ? propertySpecialServices[serviceKey] : null,
          serviceKey
        )
      )
    )
  ];

  return (
    <div>
      <Steps current={current}>
        {steps.map(item => (
          <Step key={item.title} title={item.title} />
        ))}
      </Steps>
      <div className="steps-content" style={{ paddingTop: 20 }}>
        {current !== steps.length - 1 ? (
          <PricingForm
            key={steps[current].key}
            {...formData[current]}
            onPrev={
              current > 0
                ? () => {
                    setCurrent(current - 1);
                  }
                : undefined
            }
            onNext={values => {
              setPricingValues(buildValues(values, mainKeys));
              setCurrent(current + 1);
            }}
          />
        ) : (
          <PropertyNoteForm
            key={steps[current].key}
            propertyId={propertyId}
            onPrev={() => {
              setCurrent(current - 1);
            }}
            closeForm={closeForm}
          />
        )}
      </div>
    </div>
  );
}

PropertyPricingForm.propTypes = {
  propertyPricingInfo: PropTypes.object,
  activeGlobalSetting: PropTypes.object,
  setPricingValues: PropTypes.func,
  closeForm: PropTypes.func,
  propertyId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

const mapStateToProps = state => ({
  propertyPricingInfo: PropertySelectors.selectCurrentPriceSetting(state),
  activeGlobalSetting: PropertySelectors.selectActiveGlobalSetting(state)
});

const mapDispatchToProps = dispatch => ({
  setPricingValues: values => {
    dispatch(PropertyActions.updateCurrentPropertySetting(values));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PropertyPricingForm);
